var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v("多跨协同")]),_c('div',{staticClass:"text"},[_vm._v(" 五大部门信息互联互通，开放共享包车信息，依托道路运输监测监管系统，形成真实、准确、完整的包车客运公共数据集合。 推动包车客运与旅游、教育地信息共享互通，促进运游育融合发展；完善包车客运应急事件处理调度；深化“数字打非”应用， 加强部门协调，推进共享地方公安等部门道路卡口和视频信息， 运用数字化思维和手段，找准切入点和突破口， 找到系统集成、多跨协同的解决方法和路径，有效查处包车非法经营问题。 ")])])])
}]

export { render, staticRenderFns }